import { MeResponse, User } from 'signature-public-api-sdk';
import { AppThunk } from '€slices/types';
import { actions } from './sign-up-slice';
import { actions as loginActions } from '€slices/auth';
import api from '€api/client';
import { RequestSignUpProps } from '€slices/sign-up/sign-up-types';
import { callApi } from '€slices/network';
import { RequestState } from '~/src/types/RequestState';
import { getSignUpTokenValidationState } from '€slices/sign-up/sign-up-selectors';
import { resetUserData } from '€slices/data/data-thunks';

export const requestSignUp =
    ({ username, password, token }: RequestSignUpProps): AppThunk =>
    async dispatch => {
        dispatch(resetUserData());
        dispatch(actions.requestSignUp());

        const [error, success] = await dispatch(
            callApi(api.ClientPortal.Users.create({ email: username, password } as User, token)),
        );

        if (error) {
            dispatch(actions.receivedSignUpError(error.response));

            throw error.error;
        } else {
            dispatch(loginActions.receiveValidateAuthCookieSuccess(success as MeResponse));
            dispatch(actions.receivedSignUpSuccess());
        }

        return success;
    };

export const validateRegistrationToken =
    (token): AppThunk =>
    async (dispatch, getState) => {
        const requestState = getSignUpTokenValidationState(getState());

        if (requestState === RequestState.Loading) {
            return;
        }

        dispatch(actions.validateRegToken());

        const [error, data] = await dispatch(
            callApi(api.ClientPortal.Email.validateRegistrationToken(token)),
        );

        if (error) {
            dispatch(actions.errorValidateRegToken());
        } else {
            dispatch(actions.successValidateRegToken(data));
        }
    };
